import { render, staticRenderFns } from "./HandoverTemplateSettings.vue?vue&type=template&id=b2ba7afc&scoped=true"
import script from "./HandoverTemplateSettings.vue?vue&type=script&lang=js"
export * from "./HandoverTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./HandoverTemplateSettings.vue?vue&type=style&index=0&id=b2ba7afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba7afc",
  null
  
)

export default component.exports